import { useCallback } from 'react';

import { useSelector } from 'third-party';

import { billingSelectors } from 'selectors';

import { PlanFeature } from 'types/app';

export const usePlanFeature = () => {
  const entitlement = useSelector(billingSelectors.entitlement);

  return useCallback(
    (feature: PlanFeature) => entitlement?.[feature] ?? false,
    [entitlement],
  );
};
